import React, {
  useState,
  useRef,
  useContext
}                               from 'react';
import { useTranslation }       from 'react-i18next';
import { toast }                from 'react-toastify';
import PushContext              from '../context';
import Send                     from '@material-ui/icons/Send';
import List                     from '~/containers/List';
import Request                  from '~/providers/Request';
import ModalDelete              from '~/components/ModalDelete';
import {
  showPush,
  editPush,
  createPush
}                               from '~/config/routes';
import moment                   from 'moment';
import { AbilityContext }       from '~/contexts/Can';

function PushList() {
  const { t } = useTranslation();
  const [modalInfo, setModalInfo] = useState({ show: false });
  const { delRecord } = useContext(PushContext);
  const ability = useContext(AbilityContext);
  const listEl = useRef(null);

  const trAttr = (attr) => t(`push.attributes.${attr}`);

  function handleDeletionModal(id, title){
    setModalInfo({ show: true, id, title });
  }

  async function handleDelete(){
    try {
      await Request.del(`/admin/push_messages/${modalInfo.id}`);
      delRecord(modalInfo.id);
      listEl.current.onQueryChange();
      toast.success(t('delete-toast-success'));
    } catch(e) {
      toast.error(t('delete-toast-fail'));
    } finally {
      setModalInfo({ show: false });
    }
  }

  const actions = [
    'search',
    'filter',
  ];

  if(ability.can('new', 'Pushs')) {
    actions.push('new');
  }
  if(ability.can('edit', 'Pushs')) {
    actions.push('editPush');
  }
  if(ability.can('delete', 'Pushs')) {
    actions.push('del');
  }
  if(ability.can('show', 'Pushs')) {
    actions.push('show');
  }

  return (
    <div>
      <List
        deleteAction={handleDeletionModal}
        routeToNew={createPush}
        routeToEdit={editPush}
        routeToShow={showPush}
        listEl={listEl}
        path={'/admin/push_messages/'}
        actions={actions}
        paperProps={{
          Icon: Send,
          iconColor: 'blue',
          title: t('push.defPlural'),
        }}
        columns={[
          { title: trAttr('sent_at'), field: 'sent_at', type: 'datetime' },
          { title: trAttr('title'), field: 'title', type: 'string' },
          { title: trAttr('subtitle'), field: 'subtitle', type: 'string' },
          { title: trAttr('message'), field: 'message', type: 'string' },
          { title: trAttr('send_at'), field: 'send_at', type: 'datetime' },
        ]}
        context={PushContext}
        recordMap={
          record => ({
            ...record,
            sent_at: record.sent_at ? moment(record.sent_at).format('DD/MM/YYYY HH:mm') : null,
            send_at: record.send_at ? moment(record.send_at).format('DD/MM/YYYY HH:mm') : null,
          })
        }
      />

      <ModalDelete
        id={modalInfo.id}
        name={modalInfo.title}
        modal={modalInfo.show}
        deleteAction={handleDelete}
        onClose={() => setModalInfo({ show: false })}
      />
    </div>
  );
}

export default React.memo(PushList);
